import React from "react";
import { useParams } from "react-router";
import FullLayout from "@/layouts/FullLayout";
import { appLog } from "@/features/scanners/helpers";
import { fetchWorktableStats } from "./api";
import { WorktableInfo, WorktableStats } from "./types";
import Scan from "./Scan";

export const Worktable: React.FC = () => {
  const { worktableId } = useParams();
  const id = Number(worktableId);
  const [worktable, setWorktable] = React.useState<WorktableInfo | null>(null);
  const [stats, setStats] = React.useState<WorktableStats | null>(null);
  const [error, setError] = React.useState<string>("");

  React.useEffect(() => {
    if (!Number.isFinite(id)) {
      setError("Ongeldige werktafel");
      return;
    }
    fetchWorktableStats(id)
      .then((response) => {
        setWorktable(response.worktable);
        setStats(response.stats);
      })
      .catch((err: Error) => {
        setError("Werktafel kon niet geladen worden");
        void appLog(`[WORKTABLE] fetch stats failed: ${err.message}`, true, "error", err);
      });
  }, [id]);

  return (
    <FullLayout
      header={
        <div className="flex w-full items-baseline justify-between gap-4">
          <h2>{worktable ? `Werktafel ${worktable.name}` : "Werktafel"}</h2>
          {stats && (
            <div className="text-base font-semibold">
              Vandaag verwerkt: {stats.totalCount}
              <span className="ml-2 text-sm font-normal">
                (✓ {stats.okCount} / ✗ {stats.notOkCount})
              </span>
            </div>
          )}
        </div>
      }
    >
      {error ? (
        <div className="rounded-md bg-red-500 px-4 py-3 text-center text-xl font-semibold text-white">{error}</div>
      ) : (
        <Scan worktableId={id} onStatsChange={setStats} />
      )}
    </FullLayout>
  );
};

export default Worktable;
